import * as z from "zod";

export const MandateSchema = z.object({
	id: z.string(),
	url: z.string().url(),
	reference: z.string(),
	subscriber: z.object({
		firstName: z.string(),
		lastName: z.string(),
		IBAN: z.string(),
	}),
	address: z.object({
		mainAddress: z.string(),
		city: z.string(),
		postalCode: z.string(),
		country: z.string(),
	}),
});

export type MandateDto = z.infer<typeof MandateSchema>;
